var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiobuttonchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 2C5.73333 2 2 5.73333 2 10.3333C2 14.9333 5.73333 18.6667 10.3333 18.6667C14.9333 18.6667 18.6667 14.9333 18.6667 10.3333C18.6667 5.73333 14.9333 2 10.3333 2ZM10.3333 17C6.65 17 3.66667 14.0167 3.66667 10.3333C3.66667 6.65 6.65 3.66667 10.3333 3.66667C14.0167 3.66667 17 6.65 17 10.3333C17 14.0167 14.0167 17 10.3333 17Z",
    fill: "#CDCDCD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 4.5,
    fill: "#B92E81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiobuttonchecked);
export default __webpack_public_path__ + "static/media/radiobuttonchecked.fc011cad09abb8f6d5d4d4a07d54102c.svg";
export { ForwardRef as ReactComponent };